import { render, staticRenderFns } from "./DefLayout.vue?vue&type=template&id=56a0f443&"
import script from "./DefLayout.vue?vue&type=script&lang=js&"
export * from "./DefLayout.vue?vue&type=script&lang=js&"
import style0 from "./DefLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports